import React from 'react';
import { ApolloProvider } from '@apollo/client';
import { createApolloClient } from '@Apollo/utils/createApolloClient';

/** клиент graphql */
const client = createApolloClient();

/** компонент провайдера graphql */
export const GenericApolloProvider = ({ children }) => <ApolloProvider client={client}>{children}</ApolloProvider>;
